<script setup>
import { provide, ref, computed, inject, onMounted, watch } from 'vue';
import Auth from "./components/Auth.vue";
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
import MessageBox from "./components/MessageBox.vue";
import {getApiClient} from "./services/apiClientService";


const router = inject('router');
const messageBox = ref();
const headerIcons = ref();
const authApi = ref();
const show_ai_agend = ref(false);

const CHANNEL_PRIVATE = 'private';
const CHANNEL_PUBLIC = 'public';
const channel_selected = ref(CHANNEL_PUBLIC);
const selectChannel = (channel) => {
    channel_selected.value = channel;
};

provide('channel',{
    CHANNEL_PRIVATE,
    CHANNEL_PUBLIC,
    channel_selected,
    selectChannel,
});

watch(
  () => channel_selected.value,
  (channel) => {
    if(channel === CHANNEL_PRIVATE) {
      document.getElementById('app').classList.add('private');
    }else{
      document.getElementById('app').classList.remove('private');
    }
  }
)

const file_filter = ref({
  language: {
    options: {de:'DE',en:'EN'},
    value: '',
    active: true
  },
  types: {
    options: [],
    value: [],
    active: false
  },
  search: {
    value: '',
    active: false
  },
  show_filter: false,
  show_search: false,
});

const setDefaultLanguage = function () {
  if(file_filter.value.language.value.length > 0){
    return false;
  }
  let browser_language = navigator.language.substring(0,2).toLowerCase();
  if(file_filter.value.language.options.hasOwnProperty(browser_language)){
    file_filter.value.language.value = browser_language;
  }else{
    file_filter.value.language.value = 'en';
  }
};

const setFilter = (filter) => {
  filter.value = Object.assign({},filter);
};

const resetFilter = () => {
  file_filter.value.types.value = [];
  file_filter.value.types.active = false;
}


const showFilter = (show=true) => {
  file_filter.value.show_filter = show;
  if(!show){
    resetFilter();
  }
}

const initFilterTypes = (file_types) => {
  for (let type of file_types) {
    let type_detail = type.filetype_id.replace(/FILE_/g, '');
    type.icon = type_detail.toLowerCase();
    if(type.icon === 'directory'){
      type.icon = 'project'
    }
    file_filter.value.types.options.push(type)
  }
}

const getFilterType = (filetype_id) => {
  let filetype = false;
  Object.entries(file_filter.value.types.options).forEach(([index, type]) => {
    if(filetype_id === type.filetype_id){
      filetype = type;
    }
  })
  return filetype;
}

const showSearch = (show=true) => {
  if(!show){
    resetSearch();
  }else{
    file_filter.value.show_search = show;
  }
}

const resetSearch = () => {
  file_filter.value.search.value = '';
  file_filter.value.search.active = false;
  file_filter.value.show_search = false;
}

provide('filter',{
  file_filter,
  setFilter,
  showFilter,
  resetFilter,
  getFilterType,
  showSearch,
  resetSearch
});

const loadFiletypes = function () {
    const apiClient = getApiClient();
    apiClient.get(`/file_type`,).then(response => {
        initFilterTypes(response.data);
    }).catch(error => {
          console.error(error.message);
    }).finally(() => {
      // loadingState.value = false;
    });
};

const getAuthBearer = () => {
  try {
    return authApi.value.getBearer();
  }catch (e){
    return false;
  }
};

const userLoggedIn = computed(() => {
  try {
    return authApi.value.userLoggedIn;
  }catch (e){
    return false;
  }
});

const openLogin = (callback = null) => {
  try {
    return authApi.value.openLogin(callback);
  }catch (e){
    return false;
  }
};

const userIsEmployee = computed(() =>{
  try{
    return authApi.value.userIsEmployee;
  }catch (e) {
    return false;
  }
});

provide('userApi',{
  getAuthBearer,
  userLoggedIn,
  openLogin,
  userIsEmployee
});

const shareLink = function (url) {
  navigator.clipboard.writeText(url).then(() => {
    showMessage('Share Link','Link to this file is added to your clipboard.', 'success', 'share');
  });
}

const showMessage = function (header, message, type = 'success', icon) {
  messageBox.value.addMessage(header,message, type, icon);
};

const setHeaderIcons = function (icons) {
  headerIcons.value.setIcons(icons);
};

provide('shareLink',shareLink);
provide('showMessage',showMessage);

onMounted(()=>{
  setDefaultLanguage();
  loadFiletypes();
  watch(userIsEmployee, (is_employee) =>{
    show_ai_agend.value = is_employee;
    if(!is_employee){
      document.getElementById('chatbase-bubble-button').remove()
      document.getElementById('chatbase-message-bubbles').remove()
      document.getElementById('chatbase-bubble-window').remove()
    }
  });
})

</script>

<template>
  <Auth ref="authApi"></Auth>
  <Header ref="headerIcons"></Header>
  <router-view @set-open-file-icon="setHeaderIcons"></router-view>
  <Footer @share-link="shareLink"></Footer>
  <message-box ref="messageBox"></message-box>
  <component is="script" src="https://www.chatbase.co/embed.min.js" id="LQoZKsUtIInvRprcrkjpN" domain="www.chatbase.co" async v-if="show_ai_agend"></component>
</template>